import mailingListService from './services/mailing-list.service';
import { loadMailingProfileList } from './mailing-profile';

export const MAILING_LISTS = 'mailingProfile/MAILING_LISTS';
export const CREATE_MAILING_LIST = 'mailingProfile/CREATE_MAILING_LIST';
export const DEFAULT_MAILING_LIST_CHANGED = 'mailingProfile/DEFAULT_MAILING_LIST_CHANGED';
export const CSV_DATA_CHANGED = 'mailingProfile/CSV_DATA_CHANGED';
export const UPDATE_MAILING_LIST = 'mailingProfile/updATE_MAILING_LIST';

const initialState = {
  list: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_MAILING_LIST: {
      const profileList = action.payload;
      state.list.push(profileList);
      
      return state;
    }
    case UPDATE_MAILING_LIST: {
      const profileList = action.payload;
      const index = state.list.findIndex(({id}) => id === profileList.id);

      if (index > -1) {
        state.list[index] = profileList;
      }
      
      return state;
    }
    case MAILING_LISTS: {
      return {
        ...state,
        list: action.payload
      };
    }
    case DEFAULT_MAILING_LIST_CHANGED: {
      const newDefaultMailingList = action.payload;
      const mailingList = state.list.slice();
      const lastDefaultMailingList = mailingList.find(({default: isDefault}) => isDefault);

      // remove previous default value
      if (lastDefaultMailingList) {
        lastDefaultMailingList.default = false;
      }

      // remove old value of newly selected default
      const index = mailingList.findIndex(({id}) => id === newDefaultMailingList.id);
      if (index > -1) {
        mailingList.splice(index, 1, newDefaultMailingList);
      }
      else {
        mailingList.push(newDefaultMailingList);
      }

      return {
        ...state,
        list: mailingList
      };
    }
    case CSV_DATA_CHANGED: {
      const newMailingList = action.payload;
      const mailingList = state.list.slice();
      const index = mailingList.findIndex(({id}) => id === newMailingList.id);
      
      if (index > -1) {
        mailingList.splice(index, 1, newMailingList);
      }
      else {
        console.error('mailing list not found');
        return state;
      }

      return {
        ...state,
        list: mailingList
      };
    }
    default:
      return state
  }
}

export const loadMailingList = () => {
  return (dispatch, getState) => {
    return mailingListService.getMailingLists()
      .then((mailingLists) => {
        dispatch({
          type: MAILING_LISTS,
          payload: mailingLists
        });

        loadMailingProfileList()(dispatch, getState);

        return mailingLists;
      });
  };
};

export const createMailingList = (listData) => {
  return (dispatch, getState) => {
    return mailingListService.createMailingList(listData)
      .then((profile) => {
        dispatch({
          type: CREATE_MAILING_LIST,
          payload: profile
        });

        return profile;
      });
  };
};

export const updateCSVData = (id, csvData) => {
  return (dispatch, getState) => {
    return mailingListService.updateMailingList(id, { csvData })
      .then((mailingList) => {
        dispatch({
          type: CSV_DATA_CHANGED,
          payload: mailingList
        });

        return mailingList;
      });
  };
}

export const setDefaultMailingList = (id) => {
  return (dispatch, getState) => {
    return mailingListService.updateMailingList(id, { default: true })
      .then((defaultProfile) => {
        dispatch({
          type: DEFAULT_MAILING_LIST_CHANGED,
          payload: defaultProfile
        });

        return defaultProfile;
      });
  };
}



// WEBPACK FOOTER //
// ./src/modules/mailing-list.js